import React, { useEffect, useState } from "react";
import { Col, Row, Image, Modal } from "react-bootstrap";
import ImgDoc from "../../assets/images/doc.png";
import { truncateText } from "../../constant/TruncateText";
import icNext from "../../assets/images/ic-arrow-next.svg";
import ENGModalHeader from "../modal/ENGModalHeader";
import ENGModalBody from "../modal/ENGModalBody";
import ENGModalFooter from "../modal/ENGModalFooter";
import icTitle from "../../assets/images/ic-edit-modal.svg";
const RowItem = ({
  item,
  linkTitle = "GO TO THE LINK",
  lg = 3,
  xs = 12,
  fetchLearningModuleData,
}: {
  item: any;
  linkTitle?: string;
  lg?: number;
  xs?: number;
  fetchLearningModuleData: any;
}) => {
  const [modalShow2, setModalShow2] = useState(false);
  const handleClose2 = () => setModalShow2(false);
  const handleShow2 = () => setModalShow2(true);

  return (
    <>
      <Col lg={lg} sm={lg} xs={xs}>
        <div className='desk'>
          <div style={styles.codeofconduct}>
            <a
              href={item?.materialBase64}
              rel='noopener noreferrer'
              target='_blank'
            >
              <img src={ImgDoc} style={styles.img} alt='icon' />
            </a>

            <h4 style={styles.title}>{truncateText(item?.title, 40)}</h4>
            <p style={styles.content}>{truncateText(item?.description, 50)}</p>

            {item.moduleId !== 4 &&
            item.moduleId !== 5 &&
            item.moduleId !== 6 ? (
              <a
                href={item?.externalUrl}
                rel='noopener noreferrer'
                target={item?.openURLSameWindow ? `` : `_blank`}
                style={styles.link}
              >
                {linkTitle}
                {'  '}{' '}
                <span style={{ fontSize: '18px' }}>
                  <Image
                    src={icNext}
                    style={{
                      width: '15px',
                      height: '15px'
                    }}
                  />
                </span>
              </a>
            ) : (
              <a
                href={item?.materialBase64}
                target='_blank'
                rel='noopener noreferrer'
                style={styles.link}
              >
                {linkTitle}
                {'  '}{' '}
                <span style={{ fontSize: '18px' }}>
                  <Image
                    src={icNext}
                    style={{
                      width: '15px',
                      height: '15px'
                    }}
                  />
                </span>
              </a>
            )}
          </div>
        </div>
      </Col>
      <Modal
        show={modalShow2}
        onHide={handleClose2}
        backdrop='static'
        size='lg'
        keyboard={false}
      >
        <ENGModalHeader icon={icTitle} title='View PDF' />
        <ENGModalBody
          contents={
            <>
              {/* <iframe
                src={item?.materialBase64}
                width='800'
                height='600'
              ></iframe> */}
            </>
          }
        />
        <ENGModalFooter closeMethod={handleClose2} />
      </Modal>
    </>
  );
};

const styles: any = {
  img: {
    backgroundColor: "#ececec33",
    padding: "14px",
    borderRadius: "50%",
  },
  title: {
    fontFamily: "Georama-Regular",
    fontSize: "18px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.44,
    letterSpacing: "normal",
    marginTop: "18px",
  },

  link: {
    color: "#e31837",
    float: "right",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: "bold",
    textDecoration: "none",
    position: "absolute",
    bottom: "10px",
    right: "10px",
  },

  content: {
    fontFamily: "Georama-Regular",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    color: "black",
  },

  codeofconduct: {
    border: "1px solid #eee",
    padding: "30px 16px",
    marginBottom: "20px",
    height: "250px",
    position: "relative",
  },

  codeofconductmob: {
    border: "1px solid #eee",
    padding: "25px 20px",
    MarginBottom: "10px",
  },
};

export default RowItem;
